export default "__VITE_ASSET__6c5b8b83__"